export const useSplitOrdersButton = (
  orderData: any,
  onToggleChildOrders?: (orderId: string) => void
) => {
  const shouldShowSplitOrders = orderData?.descendantOrderIds && orderData.descendantOrderIds.length > 0;
  
  const count = orderData?.descendantOrderIds?.length || 0;
  
  const handleClick = () => onToggleChildOrders?.(orderData._id);
  
  return {
    shouldShowSplitOrders,
    count,
    handleClick
  };
}; 